import Reflux from 'reflux';
import NProgress from 'nprogress';
import http from '../../helper/ajax';

const BuildActions = Reflux.createActions([
  'addNewLayout',
  'saveSettingsData',
  'publishSettingsData',
  'publishNewLayout',
  'deleteLayout',
  'saveAllBlocks',
]);


BuildActions.saveAllBlocks.preEmit = (allLayout) => {
  NProgress.start();
  jQuery('#ajax-loader').fadeIn(300);
  http.post('save_builder', allLayout).end((error, res) => {
    if (res) {
      if (allLayout.reload) {
        location.reload();
      }
      NProgress.done();
      jQuery('#ajax-loader').fadeOut(300);
      BuildActions.publishNewLayout(JSON.parse(res.text));
    }
  });
};

BuildActions.deleteLayout.preEmit = (uid) => {
  NProgress.start();
  jQuery('#ajax-loader').fadeIn(300);
  const data = { uid };
  http.post('delete_layout', data).end((error, res) => {
    if (res) {
      NProgress.done();
      jQuery('#ajax-loader').fadeOut(300);
      BuildActions.publishNewLayout(JSON.parse(res.text));
    }
  });
};


BuildActions.saveSettingsData.preEmit = (data) => {
  NProgress.start();
  http.post('save_settings', data).end((error, res) => {
    if (res) {
      NProgress.done();
      location.reload();
      // BuildActions.publishSettingsData(JSON.parse(res.text));
    }
  });
};

export default BuildActions;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/builder/action/builderActions.js
 **/